import { gql } from '@apollo/client'

export const ITTIC_REERVATION_TYPES = gql`
  query GetItticReservationTypes($tenantCode: Int!) {
    getItticReservationTypes(tenantCode: $tenantCode) {
      ID
      code
      name {
        fa
        en
      }
    }
  }
`
